import { Swiper, SwiperSlide } from 'swiper/react';
import { Col, Row, Image, } from 'antd';
import { CheckOutlined, ToTopOutlined } from '@ant-design/icons';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import storeUser from '@/store'
import 'swiper/swiper-bundle.css';
import './slider.less'

SwiperCore.use([Autoplay, Navigation]);
export default function index(props) {
	var settings = {
		dots: false,
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		vertical:true,
		autoplaySpeed: 2000,
		pauseOnHover: true,
		arrows:false,
		touchMove: true,
	};

  const { screenPriceShow } = storeUser.getState().sysuserInfo

  return (
	<div className="slider-box">
        <Swiper className="slider-inner-box" 
            spaceBetween={10}
            slidesPerView={6}
            loop
            autoplay= {{
                disableOnInteraction: false,
                delay: 3000 //3秒切换一次
            }}
            direction="vertical"
            navigation={{ prevEl: `.prev`, nextEl: `.next` }}>
            {props.datalist?.map((item,index)=>{
            return (
                <SwiperSlide key={index}>
                    <div span={12} key={index} style={{padding:'16px'}} onClick={e=>{
                        props.click(item)
                    }}>
                        <Row className='outer-box'>
                            <Col>
                                <Image className='inner-image' preview={false} width={110} src={item.picUrl} />
                            </Col>
                            <Col className='inner-cnt'>
                                <Row className='row-flex'>
                                    <Col>
                                        <div className='goods-name'>{item.productName}</div>
                                        <div className='goods-restarount'>{item.buyerRestaurantName}——{item.buyerStoreName}</div>
                                        <div className='goods-time'>采购时间：{item.createTime}</div>
                                    </Col>
                                    {screenPriceShow != "ON"
                                    ? <Col className='is-upload'>
                                        {item.examiningReportPicUrl && <><CheckOutlined style={{color:'#31ADA5'}} /><span style={{color: '#31ADA5'}}>已上传</span></>}
                                        {!item.examiningReportPicUrl && <><ToTopOutlined style={{color:'#31ADA5'}} /><span style={{color: '#31ADA5'}}>未上传</span></>}
                                    </Col>
                                    : <Col className='is-upload'>
                                    <span style={{color: '#31ADA5'}}>{"¥" + window.$util.toFixed2(item.payableUnitPrice) + "/" + item.unitName}</span>
                                    </Col>
                                    }
                                </Row>

                            </Col>
                        </Row>
                    </div>
                </SwiperSlide>
            );
            })}
        </Swiper>
			
	</div>
  );
}
